import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "./App.css";
import About from "./Components/home/About";
import ContactUs from "./Components/home/Contact";
import Demo from "./Components/home/Demo";
import KetcherExample from "./Components/KetcherExample";
import NavBar from "./Components/home/NavigationBar";
import Home from "./Components/home/Home";
import FTOReport from "./Components/home/FTOReport";
import ComingSoon from "./Components/home/ComingSoon";
import Login from "./Components/login/Login";
import ProtectedRoute from "./context/ProtectedRoute";
import PriorArtReport from "./Components/home/PriorArtReport";

import { AuthProvider } from "./context/AuthContext";
import Footer from "./Components/home/Footer";
import DrugDiscovery from "./Components/home/DrugDiscoveryt";
import ScrollToTop from "./Components/ScrollToTop";
import News from "./Components/home/News";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop/>
        <div className="app-container">
          <NavBar />
          <ToastContainer position="top-right" autoClose={5000} />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/fto-report" element={<FTOReport />} />
              <Route path="/prior-art-report" element={<PriorArtReport />} />
              <Route path="/validity-search" element={<ComingSoon />} />
              <Route path="/compound-intelligence" element={<DrugDiscovery />} />
              <Route path="/login" element={<Login />} />
              <Route path="/sign-up" element={<ComingSoon />} />
              <Route
                path="/ketcher"
                element={
                  <ProtectedRoute>
                    <KetcherExample />
                  </ProtectedRoute>
                }
              />
              <Route path="/news" element={<News />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
